import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

export const supabase = createClient(supabaseUrl, supabasePublishableKey)

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string
          email: string
          full_name: string | null
          avatar_url: string | null
          plan: 'free' | 'researcher' | 'project' | 'bootstrap' | 'startup' | 'growth'
          stripe_customer_id: string | null
          credits: number
          created_at: string
          updated_at: string
        }
        Insert: {
          id: string
          email: string
          full_name?: string | null
          avatar_url?: string | null
          plan?: 'free' | 'researcher' | 'project' | 'bootstrap' | 'startup' | 'growth'
          stripe_customer_id?: string | null
          credits?: number
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          email?: string
          full_name?: string | null
          avatar_url?: string | null
          plan?: 'free' | 'researcher' | 'project' | 'bootstrap' | 'startup' | 'growth'
          stripe_customer_id?: string | null
          credits?: number
          created_at?: string
          updated_at?: string
        }
      }
      api_keys: {
        Row: {
          id: string
          user_id: string
          name: string
          key_id: string
          unkey_id: string
          usage_count: number
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          user_id: string
          name: string
          key_id: string
          unkey_id: string
          usage_count?: number
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          name?: string
          key_id?: string
          unkey_id?: string
          usage_count?: number
          created_at?: string
          updated_at?: string
        }
      }
      usage_logs: {
        Row: {
          id: string
          user_id: string
          api_key_id: string
          endpoint: string
          timestamp: string
          credits_used: number
        }
        Insert: {
          id?: string
          user_id: string
          api_key_id: string
          endpoint: string
          timestamp?: string
          credits_used: number
        }
        Update: {
          id?: string
          user_id?: string
          api_key_id?: string
          endpoint?: string
          timestamp?: string
          credits_used?: number
        }
      }
    }
  }
}